import { Injectable } from '@angular/core';

export type DeviceType = 'Mobile/Tablet' | 'Desktop';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectorService {
  private detectDevice(): DeviceType {
    const ua = navigator.userAgent;
    const isMobileUA = /Android|iPhone|iPod/i.test(ua);
    const isTabletUA = /iPad|Tablet/i.test(ua);
    const isSmallScreen = window.innerWidth <= 1024;

    if (isMobileUA || (isTabletUA && isSmallScreen)) {
      return 'Mobile/Tablet';
    }
    return 'Desktop';
  }

  public isMobile(): boolean {
    return this.detectDevice() === 'Mobile/Tablet';
  }

  public isDesktop(): boolean {
    return this.detectDevice() === 'Desktop';
  }
}
